const Logg = (message: string) => {
  console.log(`%c ${message}`, 'background: #005aff; color: #fff; font-size: 2rem;');
};

export default Logg;
